import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Colors } from '../../../ui';
import { Badge } from '../../../ui/Badge';
import { DropButton } from '../../../ui/DropButton';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { DropZoneMode } from './DropZone';

type ButtonProps = { label: string, desc: string, selected: boolean, onSelect: () => void };

export const DropZoneModeButton = ({ label, desc, selected, onSelect }: ButtonProps) => {
    return <Flexer onClick={onSelect}>
        <DropButton wrap overflow="0" padding=".5 1" active={selected}>
            <Flexer grow flex="column" gap=".25">
                <Flexer flex="row" align="center" justify="space-between">
                    <Copy bold flush size="1.125">{label}</Copy>
                    {selected && <Badge color={Colors.primary}>ACTIVE</Badge>}
                </Flexer>
                <Copy flush size=".875">{desc}</Copy>
            </Flexer>
        </DropButton>
    </Flexer>;
};

export const DropZoneModeWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const value = useObserver(widget).value as number;

    const onSelect = (nextValue: number) => {
        widget.update({ value: nextValue, open: false });
    };

    return <Flexer width="24" padding=".5" flex="column" gap=".5">
        <DropZoneModeButton
            label="Shared Mode" desc="Shared spot for any participant to place objects."
            selected={value === DropZoneMode.shared} onSelect={() => onSelect(DropZoneMode.shared)} />
        <DropZoneModeButton
            label="Participant Mode" desc="A dedicated spot for a single participant to place objects.  Displays the participant name as the label."
            selected={value === DropZoneMode.participant} onSelect={() => onSelect(DropZoneMode.participant)} />
    </Flexer>;
});
